import { Link } from "react-router";

const HomeButton = () => {
    
    return (
        <Link to="/">
            <div className="fixed left-10 top-26 z-40 bg-gray-100 border border-gray-300 p-2 rounded-xl backdrop-blur-md" >
                <div className="relative">
                <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none"><path d="M10.07 2.82 3.14 8.37c-.78.62-1.28 1.93-1.11 2.91l1.33 7.96c.24 1.42 1.6 2.57 3.04 2.57h11.2c1.43 0 2.8-1.16 3.04-2.57l1.33-7.96c.16-.98-.34-2.29-1.11-2.91l-6.93-5.54c-1.07-.86-2.8-.86-3.86-.01Z" stroke="#777777" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M12 15.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z" stroke="#777777" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg>    
                </div>
            </div>
        </Link>
    );
}

export default HomeButton;